var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup18964(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.608,
    height: 47.608,
    viewBox: "0 0 47.608 47.608",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18964",
    "data-name": "Group 18964",
    transform: "translate(-510.076 -7031.622)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(515 7039)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "facebook",
    d: "M47.608,23.8a23.8,23.8,0,1,0-23.8,23.8c.139,0,.279,0,.418-.009V29.076H19.108v-5.96h5.114V18.727c0-5.086,3.106-7.857,7.643-7.857a41.543,41.543,0,0,1,4.584.232v5.319H33.326c-2.464,0-2.948,1.172-2.948,2.892v3.794h5.9l-.772,5.96H30.378V46.688A23.811,23.811,0,0,0,47.608,23.8Z",
    transform: "translate(510.076 7031.622)",
    fill: "#b5153a"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup18964);
export default __webpack_public_path__ + "static/media/Group 18964.222d2834db1bdb50c82a96c07ac2c71c.svg";
export { ForwardRef as ReactComponent };